// SDK构造函数
let browserInfor = {};
let getIP = false;
let getlocaltion = false;
let sIp;
let sLocaltion;
let webServiceUrl = 'https://wt.xycredit.com.cn/burydata'
// 设备类型
browserInfor.getDeviceType = function () {
  let sUserAgent = navigator.userAgent;
  let sType = sUserAgent.match(/AppleWebKit.*Mobile.*/) ? 'mobile' : 'pc';
  return sType;
};
// 浏览器
browserInfor.getBrowserInfo = function () {
  let agent = navigator.userAgent.toLowerCase();
  let regStrIE = /msie [\d.]+;/gi;
  let regStrFF = /firefox\/[\d.]+/gi;
  let regStrChrome = /chrome\/[\d.]+/gi;
  let regStrSaf = /safari\/[\d.]+/gi;
  // IE
  if (agent.indexOf('msie') > 0) {
    return agent.match(regStrIE);
  }
  // firefox
  if (agent.indexOf('firefox') > 0) {
    return agent.match(regStrFF);
  }
  // Chrome
  if (agent.indexOf('chrome') > 0) {
    return agent.match(regStrChrome);
  }
  // Safari
  if (agent.indexOf('safari') > 0 && agent.indexOf('chrome') < 0) {
    return agent.match(regStrSaf);
  }
};
// 操作系统
browserInfor.detectOS = function () {
  let systemInfo = {};
  let sUserAgent = navigator.userAgent;
  let isWin = (navigator.platform === 'Win32') || (navigator.platform === 'Windows');
  let isMac = (navigator.platform === 'Mac68K') || (navigator.platform === 'MacPPC') || (navigator.platform === 'Macintosh') || (navigator.platform === 'MacIntel');
  if (isMac) return 'Mac';
  let isUnix = (navigator.platform === 'X11') && !isWin && !isMac;
  if (isUnix) return 'Unix';
  let isLinux = (String(navigator.platform).indexOf('Linux') > -1);
  let bIsAndroid = sUserAgent.toLowerCase().match(/android/i) === 'android';
  let isIos = !!sUserAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  if (isIos) {
    let tempVer = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
    systemInfo.system = 'Ios';
    systemInfo.version = parseInt(tempVer[1], 10);
  } else if (isLinux) {
    if (bIsAndroid) {
      systemInfo.system = 'Android';
      systemInfo.version = sUserAgent.substr(sUserAgent.indexOf('Android') + 8, 5);
    } else {
      systemInfo.system = 'Linux';
    }
  } else if (isWin) {
    let system;
    let version;
    let is64 = sUserAgent.indexOf('WOW64') > -1;
    let isWin2K = sUserAgent.indexOf('Windows NT 5.0') > -1 || sUserAgent.indexOf('Windows 2000') > -1;
    if (isWin2K) system = 'Win2000';
    let isWinXP = sUserAgent.indexOf('Windows NT 5.1') > -1 || sUserAgent.indexOf('Windows XP') > -1
    sUserAgent.indexOf('Windows XP') > -1;
    if (isWinXP) system = 'WinXP';
    let isWin2003 = sUserAgent.indexOf('Windows NT 5.2') > -1 || sUserAgent.indexOf('Windows 2003') > -1;
    if (isWin2003) system = 'Win2003';
    let isWinVista = sUserAgent.indexOf('Windows NT 6.0') > -1 || sUserAgent.indexOf('Windows Vista') > -1;
    if (isWinVista) system = 'WinVista';
    let isWin7 = sUserAgent.indexOf('Windows NT 6.1') > -1 || sUserAgent.indexOf('Windows 7') > -1;
    if (isWin7) system = 'Win7';
    let isWin8 = sUserAgent.indexOf('windows nt6.2') > -1 || sUserAgent.indexOf('Windows 8') > -1;
    if (isWin8) system = 'Win8';
    systemInfo.system = system;
    if (is64) {
      systemInfo.version = '64位';
    } else {
      systemInfo.version = '32位';
    }
  } else {
    systemInfo.system = '其他';
  }
  return systemInfo;
};
// 获取屏幕分辨率(物理分辨率)
browserInfor.deviceResolution = function () {
  return window.screen.width * window.devicePixelRatio + '*' + window.screen.height * window.devicePixelRatio;
};
// 获取访问时间/当前时间
browserInfor.getTime = function () {
  let date = new Date();
  let seperator1 = '';
  let seperator2 = '';
  let month = date.getMonth() + 1;
  let strDate = date.getDate();
  let hours = date.getHours();
  let minutes = date.getMinutes();
  let seconds = date.getSeconds();
  let currentdate = date.getFullYear() + seperator1 + zerofill(month) + seperator1 + zerofill(strDate) + zerofill(hours) + zerofill(minutes) + seperator2 + zerofill(seconds);
  return currentdate;
};
// 获取网络类型
browserInfor.get_status = function () {
  let connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection || {type: 'unknown'};
  let typeText = ['unknown', 'ethernet', 'wifi', '2g', '3g', '4g', 'none'];
  if (typeof (connection.type) === 'number') {
    connection.typeText = typeText[connection.type];
  } else {
    connection.typeText = connection.type;
  }
  if (typeof (connection.bandwidth) === 'number') {
    if (connection.bandwidth > 10) {
      connection.type = 'wifi';
    } else if (connection.bandwidth > 2) {
      connection.type = '3g';
    } else if (connection.bandwidth > 0) {
      connection.type = '2g';
    } else if (connection.bandwidth === 0) {
      connection.type = 'none';
    } else {
      connection.type = 'unknown';
    }
  }
  return connection.type;
};
// 获取时区
browserInfor.get_zone = function () {
  let date = new Date();
  return 'GMT ' + date.getTimezoneOffset() / 60;
};
// 获取访问外网IP
browserInfor.get_ip = function (successCallback) {
  let isHttps = document.location.protocol === 'https:';
  let url = 'http://pv.sohu.com/cityjson?ie=utf-8';
  if (isHttps) {
    url = 'https://pv.sohu.com/cityjson?ie=utf-8';
  }
  loadScript(url, function () {
    // data=returnCitySN.cname;
    sIp = window.returnCitySN.cip;
    getIP = true;
    if (successCallback) {
      successCallback();
    }
  });
};
// 获得地理位置信息
browserInfor.getLocation = function () {
  let script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = 'http://api.map.baidu.com/location/ip?ak=wVMcdd6f9CxxYQGxH5lqmKUWmYIUmfQf&coor=bd09ll&callback=showLocation';
  document.getElementsByTagName('head')[0].appendChild(script);
};
// 调用百度地图的自定义回调函数
function showLocation(data) {
  getlocaltion = true;
  sLocaltion = data;
}
// 补零函数
function zerofill(str) {
  if (str >= 0 && str <= 9) {
    str = '0' + str;
  }
  return str
}
// 动态加载JS文件函数
function loadScript(url, callback) {
  let script = document.createElement('script');
  script.type = 'text/javascript';
  // IE
  if (script.readyState) {
    script.onreadystatechange = function () {
      if (script.readyState === 'loaded' || script.readyState === 'complete') {
        script.onreadystatechange = null;
        callback();
      }
    };
  } else {
    script.onload = function () {
      callback();
    };
  }
  script.src = url;
  document.getElementsByTagName('head')[0].appendChild(script);
}
// 原生提交请求
function post(url, data, fn) {
  let obj = new XMLHttpRequest();
  url += '?randnum=' + Math.random();
  obj.open('POST', url, true);
  obj.setRequestHeader('Content-type', 'application/x-www-form-urlencoded;charset=utf-8');
  obj.onreadystatechange = function () {
    if (obj.readyState === 4 && (obj.status === 200 || obj.status === 304)) {
      fn.call(this, obj.responseText);
    }
  };
  obj.send(data);
}
// 参数headData为json对象,content为以双下划线分割的参数字符串
// let headers={'sysId':'xyqb','pageId':'loginPage','eventId':'loginEvent'};
// let content=123+'__'+456 ;
browserInfor.statistical = function (headData, content) {
  let data = {
    'headers': headData,
    'body': {
      'content': content
    }
  };
  // 提交数据
  post(webServiceUrl, JSON.stringify(data), function (data) {
  });
};
export default {
  get_ip(callback) {
    if (sIp) {
      callback();
    } else {
      return browserInfor.get_ip(callback);
    }
  },
  getTime() {
    return browserInfor.getTime();
  },
  sIp() {
    return sIp;
  },
  resolution() {
    return browserInfor.deviceResolution()
  },
  statistical(headData, content) {
    return browserInfor.statistical(headData, content);
  }
}




// WEBPACK FOOTER //
// ./src/tools/statisticalSDK.js